import { FutureFieldTheme } from 'components/features/future/types'
import { createContext } from 'react'

export class InputThemeType {
  constructor (
    public futureFieldTitle: FutureFieldTheme | 'regular' = 'regular',
    public inputActive = false,
    public inputError = false,
    public inputDisabled = false,
  ) {}
}

export const InputThemeContext = createContext(new InputThemeType())
InputThemeContext.displayName = 'InputThemeContext'
